import {FormModalProps} from "../../../utils/useFormModal";
import {Col, Form, Input, InputNumber, Modal, Row} from "antd";

function ModifyModal(props: FormModalProps) {
    const {form, ...otherProps} = props;

    return <Modal {...otherProps}>
        <Form form={form} layout={"vertical"}>
            <Form.Item name={'id'} noStyle/>
            <Form.Item label={'试剂商品'}>
                <Input value={`${form.getFieldValue('reagentCode')}（${form.getFieldValue('reagentName')}）`}
                       disabled/>
            </Form.Item>
            <Row>
                <Col span={12}>
                    <Form.Item label={'从'} name={'fromQty'} rules={[{required: true, message: '请输入从数量'}]}>
                        <InputNumber style={{width: '100%'}} step={1} min={0}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label={'到'} name={'toQty'} rules={[{required: true, message: '请输入到数量'}]}>
                        <InputNumber style={{width: '100%'}} step={1} min={0}/>
                    </Form.Item>
                </Col>
            </Row>
            <Form.Item label={'校准商品'}>
                <Input value={(!!form.getFieldValue('calibrationCode'))?`${form.getFieldValue('calibrationCode')}（${form.getFieldValue('calibrationName')}`:''}
                       disabled/>
            </Form.Item>
            <Form.Item label={'校准数量'} name={'calibrationQty'}
                       rules={[{required: !!form.getFieldValue('calibrationCode'), message: '请输入校准数量数量'}]}>
                <InputNumber style={{width: '100%'}} step={1} min={0}/>
            </Form.Item>
            <Form.Item label={'质控商品'}>
                <Input
                    value={(!!form.getFieldValue('qualityControlCode'))?`${form.getFieldValue('qualityControlCode')}（${form.getFieldValue('qualityControlName')}`:''}
                    disabled/>
            </Form.Item>
            <Form.Item label={'质控数量'} name={'qualityControlQty'}
                       rules={[{required: !!form.getFieldValue('qualityControlCode'), message: '请输入质控数量数量'}]}>
                <InputNumber style={{width: '100%'}} step={1} min={0}/>
            </Form.Item>
            <Form.Item label={'描述'} name={'description'}>
                <Input/>
            </Form.Item>
        </Form>
    </Modal>;
}


export default ModifyModal
